import { createContext } from 'react';
// @ts-ignore
export const PaymentContext = createContext();
